export function getOpenStatus() {
    const paris = new Date(new Date().toLocaleString("en-US", { timeZone: "Europe/Paris" }));
    const day = paris.getDay();
    const mins = paris.getHours() * 60 + paris.getMinutes();
    const OPEN = 11 * 60 + 30;
    const CLOSE = 22 * 60 + 30;
    const open = day !== 0 && mins >= OPEN && mins < CLOSE;
    let label;
    if (open) {
        label = "Ouvert · jusqu'à 22h30";
    } else if (day === 0) {
        label = "Fermé · ouvre lundi à 11h30";
    } else {
        label = "Fermé · ouvre à 11h30";
    }
    return { open, label };
}
